import { render, staticRenderFns } from "./MobileRepeaterBasic.vue?vue&type=template&id=308af612&scoped=true"
import script from "./MobileRepeaterBasic.vue?vue&type=script&lang=js"
export * from "./MobileRepeaterBasic.vue?vue&type=script&lang=js"
import style0 from "./MobileRepeaterBasic.vue?vue&type=style&index=0&id=308af612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308af612",
  null
  
)

export default component.exports